<template>
  <v-app-bar class="custom-header" dense fixed dark elevation="0">
    
    <v-toolbar-title><img src="../../assets/img/adminLogo.svg" ></v-toolbar-title>
    <v-tabs v-model="tab">
      <v-tab to="/Dashboard">Dashboard</v-tab>
      <v-tab to="/licences">Licensees</v-tab>
      <v-tab to="/tiers">Tiers</v-tab>
      <v-tab to="/license-manager">License Managers</v-tab>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-tab color="primary"  v-bind="attrs"  v-on="on" >
            Configuration
          </v-tab>
        </template>
        <v-list>
          <v-list-item link to="/businessfunction" @click="tab = 'Configuration'">
            <v-list-item-title>Business Function</v-list-item-title>
          </v-list-item>
          <v-list-item link to="/designations" @click="tab = 4">
            <v-list-item-title>Designations</v-list-item-title>
          </v-list-item>
          <v-list-item link to="/departments" @click="tab = 4">
            <v-list-item-title>Departments</v-list-item-title>
          </v-list-item>
          <v-list-item link to='/ValueStreamMetrics' @click="tab = 4">
            <v-list-item-title>Value Stream Metrics</v-list-item-title>
          </v-list-item>
          <v-list-item link to="/RegistrationConfiguration" @click="tab = 4">
            <v-list-item-title @click="tab = 4">Registration Page</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-tabs>
    <v-spacer />
    <v-btn icon>
      <v-icon>help</v-icon>
    </v-btn>
    <v-btn icon>
      <v-icon>notifications</v-icon>
    </v-btn>
    <v-menu content-class="profile-dropdown" left top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>account_circle</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-title :title="getUser.email">{{
            getUser.email
          }}</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title @click="$router.push({ name: 'profileEdit' })"
            >Profile</v-list-item-title
          >
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data: () => ({
    progileOptions: [],
    tab:1
  }),
  computed: {
    ...mapGetters({
      getUser: 'users/getUser',
    }),
  },
  methods: {
    toggleLoginForms() {
      this.loginForm = !this.loginForm;
      this.forgotLoginFrom = !this.forgotLoginFrom;
    },
    login() {
      this.$router.push('/licences');
    },
    logout() {
      localStorage.clear();
      this.$router.push('/');
    },
    navigate(page){
      this.$router.push(`/${page}`)
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/colors.scss';

.custom-header {
  background: $primary-color-1 !important;
  padding: 10px 10px;
  min-height: 58px;
  z-index: 99 !important;

  .v-tab {
    color: $white !important;
  }
  
}
.v-toolbar__title {
    font-weight: 200 !important;
    font-size: 16px;
    letter-spacing: 1px;
    overflow: inherit !important;
  }
  .configBut {
    font-size: 0.875rem;
  }
.profile-dropdown {
  margin-top: 48px;
  max-width: 230px;
  .v-list-item {
    min-height: inherit;
    padding: 14px 16px;
    cursor: pointer;
    &__title {
      font-size: 14px;
    }
    &:hover {
      background: $secondary-color-1;
    }
  }
}
</style>
